import React from 'react';
import { useClassName } from 'common/hooks';
import './social-carousel.less';
import FastMarquee from 'react-fast-marquee';
import { SVGIcon } from 'common/components';

export const SocialCarousel = ({ slides }) => {
  const className = useClassName('SocialCarousel');

  return (
    <div className={className('container')}>
      <FastMarquee
        autoFill
        speed={50}
        gradient={false}
        className={className('marquee')}>
        {slides.map((slide, index) => (
          <a
            href={slide.url}
            key={`${slide.name}-${index}`}
            className={className('slide')}>
            {slide.social && (
              <div className={className('slide__icon')}>
                <SVGIcon name={`social-${slide.social}`} />
              </div>
            )}
            <img src={slide.desktop.assetUrl} alt={slide.desktop.assetAlt} />
          </a>
        ))}
      </FastMarquee>
    </div>
  );
};
